<template>
  <div class="text-center">
    <b-row>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 60rem;">
          <template v-slot:header>
            <h6 class="mb-0">[Account Name] Configured PRI&trade;</h6>
          </template>
          <b-row>
            <b-col cols="12">
              <b-avatar variant="danger" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h3>Chart</h3>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h4>Third Party Risk by [Account Name] Risk Indicators</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Deal Value = $30M</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Longevity of Relationship=< 1yr</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Third Party Type = Reseller</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Third Party Inventive = 30%</h6>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 60rem;">
          <template v-slot:header>
            <h6 class="mb-0">Sanctions PRI&trade;</h6>
          </template>
          <b-row>
            <b-col cols="12">
              <b-avatar variant="danger" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>There is a potential sanctions match at 95% match score or above. We encourage you to take additional steps to confirm the Third Parties risk status.</p>
            </b-col>
          </b-row>
          <br />
          <div class="text-left">
            <h5>Scope:</h5>
            <br />
            <p>[List Sanctions Lists searched. Suggest no more than 5 – 10 so as not to impinge on IDD service]</p>
            <p>[List Sanctions Lists searched. Suggest no more than 5 – 10 so as not to impinge on IDD service]</p>
            <p>[List Sanctions Lists searched. Suggest no more than 5 – 10 so as not to impinge on IDD service]</p>
            <p>[List Sanctions Lists searched. Suggest no more than 5 – 10 so as not to impinge on IDD service]</p>
            <br />
            <br />
            <p
              class="text-danger"
            >Please note that this is NOT a comprehensive sanctions screen against the full sanctions database (or other services such as negative media and political exposure). Nor has this third party been enabled for monitoring.</p>
            <h5 class="text-primary">Recommended Next Steps:</h5>
            <p
              class="text-primary"
            >To enable monitoring please order an Instant Due Diligence (IDD), Instant Due Diligence PLUS (IDD+) (Best Practice) or Enhanced Due Diligence (EDD) report should further scrutiny be warranted for this third party. Remediation services can also be performed to provide assurance on the match.</p>
            <br />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "PredictiveRiskComponent",
  data() {
    return {};
  }
};
</script>